import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { useSsoOAuth2Url } from "@common/hooks/useSsoOauth2Url";
import { IOAuth2Client } from "../contracts";

export function useCreateOAuth2Client() {
  const { request } = useSsoOAuth2Url();
  return useMutation(async (input: any) => {
    const variables: any = {
      name: input.name,
      type: input.type,
      tokenExpiration: input.tokenExpiration || 86400,
    };

    if (input.type === "ACCESS_TOKEN" || input.type === "PKCE") {
      variables.redirects = input.redirects;
    }

    if (input.type === "CLIENT_CREDENTIALS") {
      variables.userId = input.userId;
    }

    const { createOAuthClient } = await request(
      gql`
        mutation (
          $name: String!
          $type: OAuthClientTypeEnum!
          $redirects: [String!]
          $tokenExpiration: Int
          $userId: ID
        ) {
          createOAuthClient(
            name: $name
            type: $type
            redirects: $redirects
            tokenExpiration: $tokenExpiration
            userId: $userId
          ) {
            id
            secret
            name
            type
            redirects
            revoked
            tokenExpiration
            user {
              id
              email
            }
          }
        }
      `,
      variables
    );
    return createOAuthClient as IOAuth2Client;
  });
}
